import createStore from "astrid-helpers/src/createStore";
export const minDuration = 1000 * 60 * 10;
export const [getDuration, setDuration, useDuration] = createStore(minDuration);
export function resetDuration() {
  setDuration(minDuration);
}
//# sourceMappingURL=duration.js.map